<template>
  <div>
    <p>z: {{ z }}</p>
    <h1>{{ count }}</h1>
    <pre></pre>
    <canvas width="800" height="500"></canvas><br />
    <p>
      Running: {{ running }} <br />
      <button class="btn btn-default" id="running" @click="running = !running">
        Start/Stop
      </button>
      <button class="btn btn-default" id="calc" @click="onClickCal">
        Calculate distance</button
      ><br />
      Red: x,<br />
      Green: y,<br />
      Blue: z<br />
      <br />
      All values are in m/s<sup>2</sup>.<br />
      Δt = <span id="delta">{{ delta }}</span>
    </p>
  </div>
</template>

<script>
// var Shake = require('shake.js');
import $ from "jquery";
export default {
  data: function () {
    return {
      count: 0,
      isStop: false,
      running: true,
      deltaTime: true,
      delta: 0,
      log: "",
      coords: {
        x: [],
        y: [],
        z: [],
      },
      gap: 7,
      count: 0,
      max: 20,
      z: 0,
    };
  },
  mounted: function () {
    var vm = this;
    var coords = {
        x: [],
        y: [],
        z: [],
      },
      initTime = true;
    var e = null;

    for (var i = 160; i--; ) {
      coords.x.push(0);
      coords.y.push(0);
      coords.z.push(0);
    }

    if (window.DeviceMotionEvent) {
      alert("DeviceMotionEvent supported");
      window.addEventListener(
        "devicemotion",
        function (ev) {
          if (!vm.running) {
            return false;
          }

          e = ev.acceleration || ev.accelerationIncludingGravity;

          if (!initTime) {
            initTime = ev.timeStamp;
          } else if (initTime != "ok") {
            vm.delta = (ev.timeStamp - initTime) / 1000 + "s";
            vm.deltaTime = (ev.timeStamp - initTime) / 1000;
            initTime = ev.timeStamp;
          }

          var obj = {};
          vm.drawLine();
          for (var key in e) {
            if (typeof e[key] == "number") {
              var n = Math.round(e[key] * 10) / 10;
              r = (n >= 0 ? "+" : "") + n;
            } else {
              var r = typeof e[key];
            }
            obj[key] = r;
            coords[key] = coords[key].slice(1);
            if (vm.max <= vm.coords[key].length) {
              vm.coords[key] = vm.coords[key].slice(1);
            }
            if (!ev.acceleration && key == "z") {
              coords[key].push(9.86 - n);
              vm.coords[key].push(9.86 - n);
            } else {
              coords[key].push(e[key]);
              vm.coords[key].push(e[key]);
            }
            vm.drawC(
              coords[key],
              {
                x: "rgb(255, 0, 0)",
                y: "rgb(0, 255, 0)",
                z: "rgb(0, 0, 255)",
              }[key]
            );
          }
          vm.z = Math.abs(vm.coords["z"][vm.coords["z"].length - 1]);

          if (
            vm.coords["z"].length > 2 &&
            Math.abs(vm.coords["z"][vm.coords["z"].length - 1]) -
              Math.abs(vm.coords["z"][vm.coords["z"].length - 2]) >=
              vm.gap
          ) {
            vm.count++;
            vm.coords = {
              x: [],
              y: [],
              z: [],
            };
            // return false
          }
          // $.each(vm.coords['z'],function(index,val){

          // })
          $("pre").html(JSON.stringify(vm.coords["z"], 4, " "));
        },
        false
      );
    } else {
      $("pre").html("Not supported.");
    }
  },
  methods: {
    onClickCal: function () {
      this.calc(
        +prompt("Lower interval: (0~159)", 0),
        +prompt("Upper interval: (1~160)", 160),
        +prompt("Delta time:", this.deltaTime)
      );
    },
    onShake: function () {
      this.count++;
    },
    drawLine: function () {
      var ctx = $("canvas")[0].getContext("2d"),
        w = 800,
        h = 500,
        n = 5;
      ctx.clearRect(0, 0, w, h);
      ctx.beginPath();
      ctx.moveTo(0, h / 2);
      ctx.lineTo(w, h / 2);
      ctx.closePath();
      ctx.strokeStyle = "rgba(0, 0, 0, 0.5)";
      ctx.stroke();
      for (var i = 10 * n; i < w; i += 10 * n) {
        ctx.beginPath();
        ctx.moveTo(i, h / 2 - 5);
        ctx.lineTo(i, h / 2 + 5);
        ctx.closePath();
        ctx.strokeStyle = "rgba(0, 0, 0, 0.5)";
        ctx.stroke();
      }
    },
    drawC: function (points, color) {
      var ctx = $("canvas")[0].getContext("2d"),
        w = 800,
        h = 500,
        n = 5;

      ctx.beginPath();
      //ctx.moveTo(0,h/2);
      for (var i = 0; i < 160; i++) {
        var x = n * i,
          y = 250 - ((-1 * points[i]) / 10) * h;
        if (i == 0) {
          ctx.moveTo(x, y);
        }
        ctx.lineTo(x, y);
        ctx.moveTo(x, y);
      }
      ctx.closePath();
      ctx.strokeStyle = color;
      ctx.stroke();
    },

    calc: function (a, b, delta) {
      //d = (vi)t + (at^2)/2
      var d = 0;
      for (var i = a; i < b - 1; i++) {
        var point = [Math.abs(coords.x[i]), Math.abs(coords.x[i + 1])];
        var partial =
          (((point[0] + point[1]) * delta) / 2) * delta +
          (((point[0] + point[1]) / 2) * Math.pow(delta, 2)) / 2;
        d += partial >= 0 ? partial : 0;
      }
      d *= 2;
      alert(Math.round(d * 10000) / 100 + "cm");
    },
  },
};
</script>

<style scoped></style>
